import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-multiple-refund-modal',
  templateUrl: './multiple-refund-modal.component.html',
  styleUrls: ['./multiple-refund-modal.component.scss']
})
export class MultipleRefundModalComponent implements OnInit {
  @Input() bookeds: any[] = [];
  @Input() type: any;
  @Input() maxAmount: number = 0;
  @Input() mode: 'refund' | 'payment' = 'refund';
  values: { [uuid: string]: number } = {};
  totalEntered = 0;
  invalidAmounts = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  updateAmount(uuid: string, value: string) {
    const booked = this.bookeds.find(f => f.uuid === uuid);
    if (this.mode === 'refund' && booked?.price?.individualPrice === 0) {
      return;
    }

    const num = parseFloat(value);
    this.values[uuid] = isNaN(num) ? 0 : num;
    this.totalEntered = Object.values(this.values).reduce((a, b) => a + b, 0);

    if (this.mode === 'refund') {
      this.invalidAmounts = Object.entries(this.values).some(([uuid, amount]) => {
        const f = this.bookeds.find(booked => booked.uuid === uuid);
        const maxAmount = this.type === 'train'
          ? f?.price
          : f?.price?.individualPrice;
        return maxAmount !== undefined && amount > maxAmount;
      });
    } else {
      this.invalidAmounts = false;
    }
  }

  confirm() {
    this.activeModal.close(
      Object.entries(this.values).map(([uuid, amount]) => ({ uuid, amount }))
    );
  }

  cancel() {
    this.activeModal.dismiss();
  }

}
